import React, { useEffect, useState } from "react";
import "./PrestataireCardLike.css";
import { useSelector } from "react-redux";
import { calculateDistance } from "../../utils/geo";
import GoogleMapView from "../GoogleMapView";

const PrestataireCardLike = ({ prestataire, projet, apiUrl, onLike, onPass, isReceivedLike = false, isAlreadyMatched = false, isLikeSent = false }) => {
    const { user } = useSelector((state) => state.auth);
    const usersOnline = useSelector(state => state.online?.usersOnline || {});
    const [realDistance, setRealDistance] = useState(null);
    const [duration, setDuration] = useState(null);

    const isOnline = usersOnline[prestataire.idUser] === true;

    useEffect(() => {
        console.log(prestataire);
        if (
            !prestataire?.latitudePrestataire ||
            !prestataire?.longitudePrestataire ||
            !projet.latitudeProjet ||
            !projet.longitudeProjet
        ) return;

        const fetchRealDistance = async () => {
            try {
                const res = await fetch(
                    `${apiUrl}/api/maps?originLat=${projet.latitudeProjet}&originLng=${projet.longitudeProjet}&destLat=${prestataire.latitudePrestataire}&destLng=${prestataire.longitudePrestataire}`
                );
                const data = await res.json();
                if (data?.distance_text && data?.duration_text) {
                    setRealDistance(data.distance_text);
                    setDuration(data.duration_text);
                }
            } catch (err) {
                console.error("Erreur récupération distance Google Maps :", err);
            }
        };

        fetchRealDistance();
    }, [prestataire, projet]);

    const badge = (online) => ({
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: online ? "#d4f8d4" : "#f0f0f0",
        color: online ? "#258f25" : "#555",
        border: `1px solid ${online ? "#42c442" : "#aaa"}`,
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "13px",
        margin: "auto",
        width: "fit-content"
    });
    return (
        <div className="prestataire-card-like">
            
            {/* En-tête du prestataire */}
            <div className="presta-top">
                <img
                    src={
                        prestataire.photoProfilPrestataire
                            ? `${apiUrl}/api/files/?categorie=photosPrestataires&file=${prestataire.photoProfilPrestataire}`
                            : "../assets/default-avatar.png"
                    }
                    alt={`${prestataire.firstNamePrestataire || ""} ${prestataire.lastNamePrestataire || ""}`}
                    className="prestataire-photo"
                />

                <div className="presta-headline">
                    <span style={badge(isOnline)}>
                        {isOnline ? "En ligne" : "Hors ligne"}
                    </span>
                    <h2>{prestataire.raisonSocialePrestataire}


                    </h2>
                    <div className="presta-sub">
                        <span className="raison">{prestataire.firstNamePrestataire} {prestataire.lastNamePrestataire}</span>
                        <span className="ville">📍 {prestataire.villePrestataire} {projet && realDistance ? " - " + realDistance : ""}</span>


                    </div>
                </div>
            </div>

            {/* Description */}
            <p className="presta-description">
                {prestataire.descriptionPrestataire || "Aucune description fournie."}
            </p>

            {/* Détails techniques */}
            <div className="presta-meta">
                <div>
                    🔧 <strong>Compétences :</strong>{" "}
                    {Array.isArray(prestataire.competences)
                        ? prestataire.competences.map((c) => c.labelMetier).slice(0, 3).join(", ")
                        : "—"}
                </div>
                <div>🧭 <strong>Rayon :</strong> {prestataire.rayonIntervention ?? "—"} km</div>

                {realDistance && (
                    <div>
                        🚗 <strong>Distance :</strong> {realDistance} ({duration})
                    </div>
                )}

                {prestataire && (
                    <GoogleMapView
                        origin={{ lat: projet.latitudeProjet, lng: projet.longitudeProjet }}
                        destination={{ lat: prestataire.latitudePrestataire, lng: prestataire.longitudePrestataire }}
                    />
                )}
            </div>

            {/* Lien SIRET */}
            {prestataire.siretPrestataire && (
                <a
                    href={`https://www.societe.com/cgi-bin/search?champs=${prestataire.siretPrestataire}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="siret-button"
                >
                    🔍 Vérifier le SIRET
                </a>
            )}

            {/* Boutons Like / Pass */}
            {!isAlreadyMatched && !isLikeSent && (
                <div className="actions">
                    {!isReceivedLike ? (
                        <>
                            <button className="btn pass" onClick={onPass}>❌ Passer</button>
                            <button className="btn like" onClick={onLike}>❤️ Liker</button>
                        </>
                    ) : (
                        <>
                            <button className="pass" onClick={onPass}>❌ Refuser le match</button>
                            <button className="like" onClick={onLike}>❤️ Confirmer le match</button>
                        </>
                    )}
                </div>
            )}

        </div>
    );
};

export default PrestataireCardLike;
